export default __webpack_public_path__ + "resources/icons/d332-e6df.png";